// ==============================|| OVERRIDES - LIST ITEM BUTTON ||============================== //

export default function ListItemButton(theme) {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          margin: '3px 8px',
          borderRadius: '6px',
          paddingTop: '6px !important',
          paddingBottom: '6px !important',
          color: theme.vars.palette.text.secondary,
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          '& .MuiListItemIcon-root': {
            color: theme.vars.palette.text.secondary,
            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
          },
          '& .MuiTypography-root': {
            color: 'inherit',
            fontWeight: 500,
            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
          },
          '&:hover': {
            backgroundColor: theme.vars.palette.action.hover,
            color: theme.vars.palette.text.primary,
            '& .MuiListItemIcon-root': {
              color: theme.vars.palette.text.primary
            },
            '& .MuiTypography-root': {
              color: theme.vars.palette.text.primary
            }
          },
          '&.Mui-selected': {
            backgroundColor: `${theme.vars.palette.action.selected} !important`,
            color: theme.vars.palette.primary.main,
            borderLeft: `3px solid ${theme.vars.palette.primary.main}`,
            borderRadius: '0 6px 6px 0',
            marginLeft: '0px',
            '& .MuiListItemIcon-root': {
              color: theme.vars.palette.primary.main
            },
            '& .MuiTypography-root': {
              fontWeight: 600,
              color: theme.vars.palette.primary.main
            },
            '&:hover': {
              backgroundColor: `${theme.vars.palette.action.selected} !important`
            }
          }
        }
      }
    }
  };
}
